import { extendTheme } from "@chakra-ui/react";

export default extendTheme({
  fonts: {
    heading: "Inter",
    body: "Inter",
  },
});
